import { z } from 'zod';
import { CurrencySchema } from './stores.js';
/**
 * Historie nakupu polozek sablony: z dokoncenych nakupu, kde se polozka
 * koupila. Z ni rytmus („kupujete kazdych 5 tydnu") a vyvoj ceny.
 */
export const PurchaseSchema = z.object({
    /** Kdy byl nakup dokoncen. */
    date: z.iso.datetime(),
    /** Skutecna cena, jinak ocekavana. */
    priceMinor: z.number().int().nonnegative().nullable(),
    currency: CurrencySchema.nullable(),
    qty: z.number().positive(),
});
export const ItemHistorySchema = z.object({
    catalogItemId: z.uuid(),
    /** Od nejnovejsiho. */
    purchases: z.array(PurchaseSchema),
});
export const HistoryResponseSchema = z.object({ items: z.array(ItemHistorySchema) });
export const MAX_PURCHASES_PER_ITEM = 12;
/** Od jakeho podilu obvykleho odstupu se polozka nabizi jako „asi dochází". */
export const DUE_RATIO = 0.85;
const DAY_MS = 86_400_000;
/**
 * Rytmus z dat nakupu v libovolnem poradi. Nakupy v jeden den se pocitaji
 * jednou; pod dvema ruznymi dny rytmus neni. Median, ne prumer — jeden
 * vynechany mesic by prumer roztahl.
 */
export function purchaseRhythm(dates, now = new Date()) {
    const days = [
        ...new Set(dates.map((d) => Math.floor(Date.parse(d) / DAY_MS)).filter((d) => Number.isFinite(d))),
    ].sort((a, b) => a - b);
    if (days.length < 2)
        return null;
    const gaps = days.slice(1).map((day, i) => day - (days[i] ?? day)).sort((a, b) => a - b);
    const mid = Math.floor(gaps.length / 2);
    const median = gaps.length % 2 === 1 ? (gaps[mid] ?? 0) : ((gaps[mid - 1] ?? 0) + (gaps[mid] ?? 0)) / 2;
    const intervalDays = Math.max(1, Math.round(median));
    const last = days[days.length - 1] ?? 0;
    const daysSinceLast = Math.max(0, Math.floor(now.getTime() / DAY_MS) - last);
    return { intervalDays, daysSinceLast, dueRatio: daysSinceLast / intervalDays };
}
//# sourceMappingURL=history.js.map